/* eslint-disable jsx-a11y/anchor-is-valid */
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTable, KTableHeader, KTableLoading} from '../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../contexts/KTableProvider'
import {SelectOption} from '../../../../../models/utility.model'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {RatioCheckinOutData} from '../../../models/reports.model'
import {RetiredGuestColumnModel} from '../../guests/model/retired.model'

interface Props {
  datos: RatioCheckinOutData[]
  loading: boolean
  getRetiredGuests: (data: any) => void
  total: number
}

const TableRetiredGuests: FC<Props> = ({datos, loading, getRetiredGuests, total}) => {
  const {setPagination, pagination, updateTable, setUpdateTable, clearTable, setClearTable} =
    useKTable()
  const [documentTypes, setDocumentTypes] = useState<SelectOption[]>([])

  const {getDocumentTypesByCode} = useCentralServices()

  ///
  ///
  useEffect(() => {
    getDocumentTypesFn()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDocumentTypesFn = async () => {
    const data = await getDocumentTypesByCode()
    setDocumentTypes(data)
  }

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getRetiredGuests({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getRetiredGuests({})
      } else {
        setPagination({...pagination, currentPage: 1, perPage: 10})
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    getRetiredGuests({pageNumber: pagination.currentPage, size: pagination.perPage})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setPagination({...pagination, totalResults: total})
  }, [total])

  const columns: Column<RetiredGuestColumnModel>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            searcheable
            number
          />
        ),
        accessor: 'NroReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='CodigoModulo'
            searcheable
          />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='CodigoHabitacion'
            searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CodigoCama'
            searcheable
          />
        ),
        accessor: 'Cama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo Doc.'
            name='TipoDoc'
            data={documentTypes}
            selecteable
          />
        ),
        accessor: 'TipoDoc',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Doc.' name='NroDoc' searcheable />
        ),
        accessor: 'NroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Huésped' name='HuespedNombres' searcheable />
        ),
        accessor: 'HuespedNombre',
      },
    ],
    [documentTypes],
  )

  return (
    <>
      {/* <KTCard shadow className='m-5'> */}
      {loading ? <KTableLoading title='Cargando...' /> : null}
      <KTable data={datos} columns={columns as any} />
      {/* </KTCard> */}
    </>
  )
}

const TableRetiredGuestsWrapper: FC<Props> = ({datos, loading, getRetiredGuests, total}) => {
  return (
    <KTableProvider>
      <TableRetiredGuests
        datos={datos}
        loading={loading}
        getRetiredGuests={getRetiredGuests}
        total={total}
      />
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableRetiredGuestsWrapper}
